import { useState, useEffect, useMemo } from 'react';

import dayjs from 'dayjs';

import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import otherExpenseService from '../../service/otherExpense.service';
import { getProjectOrderNumberName } from '../../utils/getProjectOrderNumberName';
import useParam from '../../context/ParamContext';

const OtherExpenseReports = ({ refetch, values, viewField, operatorsDisabled, autocompleteOptions, rowSelection }) => {
  const { params } = useParam();
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'date', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    otherExpenseService.getRows(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'date',
      headerName: 'Dátum',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.date);
      },
      renderCell: (data) => {
        return dayjs(data.row.date).format('YYYY.MM.DD');
      },
    },
    {
      field: 'costAndRevenueTypeId',
      headerName: 'Költség fajta',
      type: 'singleSelect',
      sortable: false,
      valueOptions: autocompleteOptions.costAndRevenue,
      renderCell: (data) => {
        return data.row.costAndRevenueType?.name;
      },
    },
    {
      field: 'costCenterCode',
      headerName: 'Költséghely',
      type: 'singleSelect',
      sortable: false,
      valueOptions: autocompleteOptions.costCenter,
      renderCell: (data) => {
        return data.row.costCenter?.name;
      },
    },
    {
      field: 'projectId',
      headerName: 'Projekt',
      type: 'string',
      renderCell: (data) => {
        return data.row.project?.projectName;
      },
    },
    {
      field: 'projectOrderNumber',
      headerName: getProjectOrderNumberName(params),
      type: 'string',
      sortable: false,
      renderCell: (data) => {
        return data.row.project?.orderNumber;
      },
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.otherExpense}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default OtherExpenseReports;
